import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { createFeature, provideState } from '@ngrx/store';

import * as ChatEffects from '@lib/chat/core/store/chat.effects';
import { chatReducer } from '@lib/chat/core/store/chat.reducer';

export const chatFeature = createFeature({
  name: 'chat',
  reducer: chatReducer,
});

export function provideChatState(): EnvironmentProviders {
  return makeEnvironmentProviders([provideState(chatFeature), provideEffects(ChatEffects)]);
}
